exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-button[data-v-8f2ed962] {\r\n    width: 32px;\r\n    height: 32px;\r\n    min-width: 32px;\n}\n.alert-z[data-v-8f2ed962] {\r\n    z-index: 0 !important;\n}\r\n", ""]);

// exports
